/* import __COLOCATED_TEMPLATE__ from './handoff-to-external-agent.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type IntlService from 'ember-intl/services/intl';
import type HandoffToExternalAgent from 'embercom/models/operator/visual-builder/step/handoff-to-external-agent';
import type Integration from 'embercom/models/standalone/integration';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

interface Args {
  step: HandoffToExternalAgent;
  isPreview?: boolean;
  isEditing?: boolean;
  isFocused?: boolean;
  onValidChange?: (isValid: boolean) => void;
  readOnly?: boolean;
}

export default class HandoffToExternalAgentComponent extends Component<Args> {
  @service declare intl: IntlService;
  @service declare finStandaloneService: FinStandaloneService;

  @tracked availableIntegrations: Integration[] = [];
  @tracked isLoading = false;
  @tracked loadError = false;

  get integrationDisplayName() {
    // First try to find by ID, then fall back to type
    let integration;

    if (this.args.step.integrationId) {
      integration = this.finStandaloneService.standaloneIntegrations.find(
        (i) => i.id === this.args.step.integrationId,
      );
    }

    return integration?.displayName;
  }

  get stepTitle() {
    return this.intl.t('operator.workflows.visual-builder.handoff-to-external-agent.title', {
      integration: this.integrationDisplayName,
      htmlSafe: true,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::HandoffToExternalAgent': typeof HandoffToExternalAgentComponent;
  }
}
